import React from 'react'
import "./Footer.css"
import { Headings, Logo } from '../../Module_Exporter/Module_Exporter';
import { Get_Date_Object, generate_random } from '../../functions/functions';
import { AgencyName, footer_data } from '../../functions/DefaultValues';
import { NavLink } from 'react-router-dom';
function Footer() {
  return (
    <footer data-aos="zoom-in"  id='main_footer'>
        <div className="footer_brand_container">
            <img src={Logo} alt="Logo" />
            <p>{footer_data.footer_description()}</p>
        </div>
        <div className="footer_links">
        <Headings justheading={true} title1={footer_data.footer_heading_titles[0].t1} 
         title2={footer_data.footer_heading_titles[0].t2} cl="footer_headings" w="63%" c="c2"/>
         {
          footer_data.footer_important_links.map((e,i)=><NavLink key={i+generate_random(6)} to={e.url} end >{e.title}</NavLink>)
         }
        </div>



        <div className="footer_links">
         <Headings justheading={true} title1={footer_data.footer_heading_titles[1].t1} 
         title2={footer_data.footer_heading_titles[1].t2} cl="footer_headings" w="41%" c="c2"/>
         {
          footer_data.footer_principles_pages_links.map((e,i)=><NavLink className={({ isActive, isPending }) =>
          isPending ? "pending" : isActive ? "active" : ""
        } key={i+generate_random(6)}  to={e.url} 

           end>{e.title}</NavLink>)
         }
        </div>


        <div className="copyright">
           <small>&copy; Copyright {Get_Date_Object().getFullYear()}, All Right Reserved | <span className="AgencyName">{AgencyName}</span></small>
           <address className="footer_social_icons">
            {
              footer_data.footerIconLinks.map((e,i)=> <a target='_blank' rel=" noopener  author noreferrer"  key={i+generate_random(4)} href={e.url}>
              <i className={e.icon}></i>
            </a>)

            }
           
         

           </address>
        </div>
    </footer>
  )
}

export default Footer